import { generateClient } from "aws-amplify/api";
import { updateImage } from "../graphql/mutations";
import { Image } from "db/definitions";

export async function updateImageDocInDb(updatedImage: Image): Promise<void> {
	const client = generateClient({ authMode: "userPool" });
	await client.graphql({
		query: updateImage,
		variables: {
			input: updatedImage as any,
		},
		authMode: "userPool",
	});
}
